const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegends(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "30 55 120 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-688.7-391.4h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-676.7-396.8-682.1-391.4-688.7-391.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-688.7-162.8h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-676.7-168.2-682.1-162.8-688.7-162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-688.7,65.9h-133.9c-6.6,0-12-5.4-12-12V-80c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12V53.9C-676.7,60.5-682.1,65.9-688.7,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-688.7,294.5h-133.9c-6.6,0-12-5.4-12-12V148.6c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-676.7,289.1-682.1,294.5-688.7,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-688.7,523.1h-133.9c-6.6,0-12-5.4-12-12V377.3c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-676.7,517.7-682.1,523.1-688.7,523.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-688.7,751.8h-133.9c-6.6,0-12-5.4-12-12V605.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-676.7,746.4-682.1,751.8-688.7,751.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-688.7,980.4h-133.9c-6.6,0-12-5.4-12-12V834.5c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-676.7,975-682.1,980.4-688.7,980.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-688.7,1209h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12V1197C-676.7,1203.6-682.1,1209-688.7,1209z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 145.1,
    y1: 75.7,
    x2: 63,
    y2: 75.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 145.1,
    y1: 41.8,
    x2: 63,
    y2: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 145.1,
    y1: 109.5,
    x2: 63,
    y2: 109.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 37,
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 68.4,
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.5,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 99.8,
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.5,
    height: 14.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegends);
export default __webpack_public_path__ + "static/media/Legends.fd58a7267c83cfdae9042e7552f77428.svg";
export { ForwardRef as ReactComponent };